import { Building2, CheckCircle } from "lucide-react";

const CompaniesSection = ({ t, styles, allCompanies, selectedCompanies, onToggle, onToggleAll, theme }) => (
  <div style={{
    borderRadius: "12px",
    border: `2px solid ${theme === "dark" ? "rgba(226,232,240,0.1)" : "rgba(15,23,42,0.1)"}`,
    padding: "20px",
    backgroundColor: theme === "dark" ? "rgba(30,41,59,0.5)" : "rgba(248,250,252,0.8)",
    background: theme === "dark"
      ? "linear-gradient(135deg, rgba(30,41,59,0.5) 0%, rgba(15,23,42,0.3) 100%)"
      : "linear-gradient(135deg, rgba(248,250,252,0.8) 0%, rgba(240,249,255,0.6) 100%)",
    transition: "all 0.3s ease"
  }}>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Building2 size={20} style={{ color: "#2E7CBA" }} />
        <div style={{
          fontSize: "15px",
          fontWeight: "700",
          color: theme === "dark" ? "#f1f5f9" : "#0f172a"
        }}>
          {t.companies}
        </div>
        <div style={{
          fontSize: "12px",
          padding: "2px 8px",
          borderRadius: "6px",
          backgroundColor: "rgba(46, 124, 186, 0.2)",
          color: "#2E7CBA",
          fontWeight: "600"
        }}>
          {selectedCompanies.length}/{allCompanies.length}
        </div>
      </div>
      {allCompanies.length > 0 && (
        <label style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: "pointer",
          padding: "6px 12px",
          borderRadius: "6px",
          transition: "all 0.2s ease"
        }}
        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.05)"}
        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = "transparent"}>
          <input
            type="checkbox"
            checked={allCompanies.length > 0 && allCompanies.every((c) => selectedCompanies.includes(c))}
            onChange={onToggleAll}
            style={{
              width: "18px",
              height: "18px",
              cursor: "pointer",
              accentColor: "#2e7cba"
            }}
          />
          <span style={{ fontSize: "13px", fontWeight: "500", color: theme === "dark" ? "#cbd5e1" : "#475569" }}>{t.selectAll}</span>
        </label>
      )}
    </div>
    <div style={{ display: "grid", gap: "8px" }}>
      {allCompanies.length === 0 ? (
        <p style={{ margin: 0, fontSize: "13px", color: theme === "dark" ? "rgba(226,232,240,0.5)" : "rgba(15,23,42,0.5)" }}>{t.noCompanies}</p>
      ) : (
        allCompanies.map((co) => {
          const isSelected = selectedCompanies.includes(co);
          const initials = co?.charAt(0)?.toUpperCase() || "C";
          
          return (
            <button
              key={co}
              onClick={() => onToggle(co)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "12px 14px",
                borderRadius: "8px",
                border: `1px solid ${isSelected ? "rgba(46, 124, 186, 0.3)" : theme === "dark" ? "rgba(226,232,240,0.08)" : "rgba(15,23,42,0.08)"}`,
                backgroundColor: isSelected ? "rgba(46, 124, 186, 0.12)" : "transparent",
                cursor: "pointer",
                transition: "all 0.3s ease",
                background: "none",
                fontFamily: "inherit",
                textAlign: "left"
              }}
              onMouseEnter={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = theme === "dark" ? "rgba(226,232,240,0.05)" : "rgba(15,23,42,0.03)";
                  e.currentTarget.style.transform = "translateX(4px)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isSelected) {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.transform = "translateX(0)";
                }
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "14px", flex: 1 }}>
                <input
                  type="checkbox"
                  checked={isSelected}
                  onChange={() => onToggle(co)}
                  style={{
                    width: "20px",
                    height: "20px",
                    cursor: "pointer",
                    accentColor: "#2e7cba",
                    flexShrink: 0
                  }}
                />
                <div style={{
                  width: "32px",
                  height: "32px",
                  borderRadius: "6px",
                  backgroundColor: "rgba(46, 124, 186, 0.2)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#2E7CBA",
                  fontWeight: "700",
                  fontSize: "13px",
                  flexShrink: 0
                }}>
                  {initials}
                </div>
                <span style={{
                  fontSize: "14px",
                  fontWeight: isSelected ? "600" : "500",
                  color: isSelected ? "#2E7CBA" : (theme === "dark" ? "#cbd5e1" : "#475569")
                }}>
                  {co}
                </span>
              </div>
              {isSelected && <CheckCircle size={20} style={{ color: "#2e7cba", flexShrink: 0 }} />}
            </button>
          );
        })
      )}
    </div>
  </div>
);

export default CompaniesSection;

